
import React                                from 'react';
import EventManager                         from '@brainscape/event-manager';
import UiHelper                             from '_utils/UiHelper';
import ReactHelper                          from '_utils/ReactHelper';
import RelatedSubjectsBannerController      from '_controllers/RelatedSubjectsBannerController';
import contentAuthoringJson                 from '../../animations/content-authoring.json';
import classStatisticsBar                   from '../../shared/class-statistics-bar';
import marketSearchBar                      from '../../shared/market-search-bar';
import videoModal                           from '../../shared/video-modal';
import flashcardMakerLinkModal              from './flashcard-maker-link-modal';
import lottie                               from 'lottie-web';


let bccBanner,
    bodyElem,
    classStatistics,
    desktopDashboardAnimation,
    desktopLottie,
    flashcardMakerProfileLink,
    isCurrentUserAdmin,
    isDesktopView,
    privateUgc,
    spacedRepetitionAnim,
    startStudyingCtas,
    ugcClass,
    watchClassIntroVideoButton,
    watchVideoButton;

const ugcClassPage = {

  init: function () {

    /*
    ==================================================
      CACHE DOM ELEMENTS
    ==================================================
    */

    bodyElem = document.querySelector('body');
    privateUgc = document.querySelector('.private-ugc');
    isCurrentUserAdmin = document.querySelector('.is-admin');
    ugcClass = document.querySelector('.ugc-class-page');

    if (bodyElem) {
      bccBanner = bodyElem.querySelector('#related-subjects-banner-controller');
      isDesktopView = bodyElem.classList.contains('desktop-web'); 
    }

    if (ugcClass && privateUgc && isCurrentUserAdmin) {
      startStudyingCtas = ugcClass.querySelectorAll('.nav-registration-modal-trigger');
    }

    if (ugcClass && !privateUgc) {
      classStatistics = ugcClass.querySelector('.band-3 .class-statistics-items');
      desktopDashboardAnimation = ugcClass.querySelector('.band-7 #content-authoring-animation');
      flashcardMakerProfileLink = ugcClass.querySelector('.band-2 .flashcard-maker-profile-link');
      spacedRepetitionAnim = ugcClass.querySelector('.band-6 .spaced-repetition-anim');
      startStudyingCtas = ugcClass.querySelectorAll('.nav-registration-modal-trigger');
      watchClassIntroVideoButton = ugcClass.querySelector('.band-2 .watch-video-button');
      watchVideoButton = ugcClass.querySelector('.band-8 .bsc-intro-video-image');
    }    

    /*
    ==================================================
    RENDER REACT COMPONENTS
    ==================================================
    */

    ReactHelper.renderComponent(<RelatedSubjectsBannerController />, '#related-subjects-banner-controller');

    /*
    ==================================================
    INIT SEARCHBAR
    ==================================================
    */

    marketSearchBar.init({
      onFocus: this.handleSearchBarFocus,
      selector: '.search-action',
      shouldSuppressInitialFocus: false,
    });

    /*
    ==================================================
      WIRE BEHAVIORS
    ==================================================
    */

    if (classStatistics) {
      this.handleCountersObserver();
    }

    if (desktopDashboardAnimation) {
      this.handleLottieAnimationObserver(desktopDashboardAnimation);
    }

    if (flashcardMakerProfileLink) {
      if (!this.isUserLoggedIn()) {
        flashcardMakerProfileLink.removeAttribute('href');
        flashcardMakerProfileLink.addEventListener('click', () => {
          this.handleOpenFlashcardMakerLinkModalRequest();
        });
      } 
    }


    if (isDesktopView && bccBanner) {
      this.handleRelatedSubjectsBanner();
    }

    // if (makeFlashcardsCta) {
    //   this.handleMakeFlashcardsProxyClick();
    // }

    if (spacedRepetitionAnim) {
      this.handleSpacedRepetitionObserver();
    }

    if (startStudyingCtas) {
      this.handleStartStudyingProxyClick();
    }

    if (watchVideoButton) {
      let videoUrl = watchVideoButton.getAttribute('data-video-url') || null;

      watchVideoButton.addEventListener('click', () => {
        this.handleOpenVideoModalRequest(videoUrl);
      });
    }

    if (watchClassIntroVideoButton) {
      let videoUrl = watchClassIntroVideoButton.getAttribute('data-video-url') || null;

      watchClassIntroVideoButton.addEventListener('click', () => {
        this.handleOpenVideoModalRequest(videoUrl);
      });
    }

    /*
    ==================================================
      INIT LOTTIE ANIMATION
    ==================================================
    */

    desktopLottie = lottie.loadAnimation({
      container: document.getElementById('content-authoring-animation'),
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: contentAuthoringJson,
    });
  },

  /*
  ==================================================
    EVENT HANDLERS
  ==================================================
  */

  handleCloseFlashcardMakerLinkModalRequest() {
    this.isFlashcardMakerLinkModalOpen(false);
  },

  handleCountersObserver() {
    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          classStatisticsBar.init();
          observer.unobserve(classStatistics.querySelector('.decks'));
        }
      });
    });

    observer.observe(classStatistics.querySelector('.decks'));
  },

  handleCloseVideoModalRequest() {
    this.isVideoModalOpen(false);
  },

  handleOpenVideoModalRequest(videoUrl) {
    this.isVideoModalOpen(true, videoUrl);
  },

  handleLottieAnimationObserver(target) {
    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        entry.isIntersecting ? this.handlePlayLottieAnimation(target) : this.handleStopLottieAnimation(target);
      });
    });

    observer.observe(target);
  },

  handleOpenFlashcardMakerLinkModalRequest() {
    this.isFlashcardMakerLinkModalOpen(true);
  },

  handlePlayLottieAnimation(animationName) {
    if (animationName === desktopDashboardAnimation) {
      desktopLottie.play();
    }
  },

  handleSpacedRepetitionObserver() {
    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          let animateElems = spacedRepetitionAnim.querySelectorAll('.square');

          UiHelper.animateElemsIn(spacedRepetitionAnim, animateElems);
        }
      });
    });

    observer.observe(spacedRepetitionAnim);
  },

  handleStopLottieAnimation(animationName) {
    if (animationName === desktopDashboardAnimation) {
      desktopLottie.stop();
    }
  },

  handleStartStudyingProxyClick() {
    const hasLoggedInClass = document.querySelector('.navbar.is-current-user');
    const hiddenRegistrationLinkSelector = hasLoggedInClass ? '.navbar .hidden-registration-link' : '.navbar .hidden-registration-link .registration-button'; 

    let hiddenRegistrationLink = document.querySelector(hiddenRegistrationLinkSelector);

    startStudyingCtas.forEach((startStudyingCta) => {
      startStudyingCta.addEventListener('click', () => {
        hiddenRegistrationLink.click();
      });
    });
  },

  handleRelatedSubjectsBanner() {
    const relatedSubjects = bccBanner.getAttribute('data');

    setTimeout(() => {
      this.triggerRelatedSubjectsBannerOpen(JSON.parse(relatedSubjects));
    }, 3000);
  },

  /*
  ==================================================
   EVENT TRIGGERS
  ==================================================
  */

  triggerRelatedSubjectsBannerOpen(relatedSubjects) {
    EventManager.emitEvent('related-subjects-banner:open', {
      addClasses:       'related-subjects-banner',
      id:               'bcc-banner',
      relatedSubjects: relatedSubjects,
    });
  },


  /*
  ==================================================
    LOCAL UTILS
  ==================================================
  */

  isFlashcardMakerLinkModalOpen(isOpen = false) {
    flashcardMakerLinkModal.render({
      isOpen: isOpen,
      onCloseRequest: () => this.handleCloseFlashcardMakerLinkModalRequest(),
      selector: '.modals',
    });
  },

  isUserLoggedIn() {
    if (ugcClass.classList.contains('logged-in')){
      return true;
    }
  },

  isVideoModalOpen(isOpen = false, videoUrl = null) {
    videoModal.render({
      isOpen: isOpen,
      onCloseRequest: () => this.handleCloseVideoModalRequest(),
      selector: '.modals',
      shouldAutoPlay: true,
      videoUrl: videoUrl,
    });
  },
};

export default ugcClassPage;
